module.exports = __webpack_public_path__ + "img/logonya.d6c07a14.jpg";